import { render, staticRenderFns } from "./location-list-table.vue?vue&type=template&id=59c50228&"
import script from "./location-list-table.vue?vue&type=script&lang=js&"
export * from "./location-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports